import React from 'react';
import { Tabs } from 'src/components';

function SettingsTabs() {
  const tabs = [
    {
      label: 'Currencies',
      to: '/settings/currencies',
    },
    {
      label: 'Locations',
      to: '/settings/locations',
    },
    {
      label: 'Skills',
      to: '/settings/skills',
    },
    {
      label: 'Candidate Job Titles',
      to: '/settings/candidate-job-titles',
    },
  ];

  return (
    <div className="px-[2%] pt-[16px] w-[100%]">
      <Tabs
        tabs={tabs}
        classes={{
          root: 'w-[12%] min-h-[52px] font-bold normal-case text-sm leading-tight tracking-tight',
          activeRoute: '',
          lastIndex: '',
          firstIndex: '',
          container: '',
        }}
        showHighLight
      />
    </div>
  );
}

export default SettingsTabs;
